// Procedurally generated ambience (no audio files, royalty-free by construction).
let ctx = null; let nodes = null; let master = null;

const MAX_GAIN = 0.18; // kept well under the coach voice
export const AMBIENCE = [{ id: 'off', label: 'Off' }, { id: 'ocean', label: 'Ocean' }, { id: 'rain', label: 'Gentle rain' }];
export const loadAmbience = () => ({
  sound: localStorage.getItem('regen_breath_ambience') || 'off',
  volume: +(localStorage.getItem('regen_breath_ambience_vol') ?? 35),
});
export const saveAmbience = (sound, volume) => {
  localStorage.setItem('regen_breath_ambience', sound);
  localStorage.setItem('regen_breath_ambience_vol', String(volume));
};

const noiseBuffer = (c, brown) => {
  const len = c.sampleRate * 4; const buf = c.createBuffer(2, len, c.sampleRate);
  for (let ch = 0; ch < 2; ch++) {
    const d = buf.getChannelData(ch); let last = 0, b0 = 0, b1 = 0, b2 = 0;
    for (let i = 0; i < len; i++) {
      const w = Math.random() * 2 - 1;
      if (brown) { last = (last + 0.02 * w) / 1.02; d[i] = last * 3.5; }
      else { b0 = 0.997 * b0 + w * 0.029591; b1 = 0.985 * b1 + w * 0.032534; b2 = 0.95 * b2 + w * 0.048056; d[i] = (b0 + b1 + b2 + w * 0.1848) * 0.6; }
    }
  }
  return buf;
};

const build = (c, sound) => {
  const src = c.createBufferSource(); src.buffer = noiseBuffer(c, sound === 'ocean'); src.loop = true;
  const out = c.createGain(); const extra = [];
  if (sound === 'ocean') {
    const lp = c.createBiquadFilter(); lp.type = 'lowpass'; lp.frequency.value = 700;
    const swell = c.createGain(); swell.gain.value = 0.55;
    const lfo = c.createOscillator(); lfo.frequency.value = 0.09; // ~11 s waves
    const depth = c.createGain(); depth.gain.value = 0.45;
    lfo.connect(depth).connect(swell.gain);
    src.connect(lp).connect(swell).connect(out); lfo.start(); extra.push(lfo);
  } else {
    const hp = c.createBiquadFilter(); hp.type = 'highpass'; hp.frequency.value = 500;
    const lp = c.createBiquadFilter(); lp.type = 'lowpass'; lp.frequency.value = 5000;
    src.connect(hp).connect(lp).connect(out);
  }
  src.start();
  return { out, stop: () => { [src, ...extra].forEach(n => { try { n.stop(); } catch { /* already stopped */ } }); } };
};

const target = (vol) => MAX_GAIN * Math.max(0, Math.min(100, vol)) / 100;

// Must be first called from a tap (mobile autoplay rules).
export const startAmbience = (sound, volume) => {
  stopAmbience(0);
  if (sound === 'off') return;
  try {
    ctx = ctx || new (window.AudioContext || window.webkitAudioContext)();
    if (ctx.state === 'suspended') ctx.resume();
    master = ctx.createGain(); master.gain.setValueAtTime(0, ctx.currentTime);
    master.gain.linearRampToValueAtTime(target(volume), ctx.currentTime + 2.5);
    master.connect(ctx.destination);
    nodes = build(ctx, sound); nodes.out.connect(master);
  } catch { nodes = null; }
};

export const setAmbienceVolume = (volume) => {
  if (master && ctx) master.gain.setTargetAtTime(target(volume), ctx.currentTime, 0.1);
};

export const stopAmbience = (fade = 0.8) => {
  if (!nodes || !ctx) return;
  const n = nodes; const m = master; nodes = null; master = null;
  m.gain.cancelScheduledValues(ctx.currentTime);
  m.gain.setValueAtTime(m.gain.value, ctx.currentTime);
  m.gain.linearRampToValueAtTime(0, ctx.currentTime + fade);
  setTimeout(() => { n.stop(); m.disconnect(); }, fade * 1000 + 50);
};

export const ambiencePlaying = () => !!nodes;
